var map = {
	"./ui_icon_grade_0_0.png": 15625,
	"./ui_icon_grade_1_0.png": 40632,
	"./ui_icon_grade_2_1.png": 99475,
	"./ui_icon_grade_2_2.png": 83924,
	"./ui_icon_grade_2_3.png": 22405,
	"./ui_icon_grade_3_1.png": 61915,
	"./ui_icon_grade_3_2.png": 55502,
	"./ui_icon_grade_3_3.png": 35098,
	"./ui_icon_grade_4_1.png": 62755,
	"./ui_icon_grade_4_2.png": 7906,
	"./ui_icon_grade_4_3.png": 11584,
	"./ui_icon_grade_5_1.png": 74281,
	"./ui_icon_grade_5_2.png": 51626,
	"./ui_icon_grade_5_3.png": 31624,
	"./ui_icon_grade_6_1.png": 82798,
	"./ui_icon_grade_6_2.png": 23597,
	"./ui_icon_grade_6_3.png": 99765
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 67587;